import type { IKnowledgeFileAccessRevokedNotificationData } from "@frontend-shared/types";
import { FileX } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IKnowledgeFileAccessRevokedCardProps {
  uuid: string;
  data: IKnowledgeFileAccessRevokedNotificationData;
  createdAt: string;
  isRead: boolean;
}

const KnowledgeFileAccessRevokedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
}: IKnowledgeFileAccessRevokedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="knowledge_file_access_revoked"
      createdAt={createdAt}
      isRead={isRead}
      icon={<FileX className="h-5 w-5 text-destructive" />}
      iconBgClassName="bg-destructive/10"
      body={t("type.knowledge_file_access_revoked.body", {
        actorName: data.actorName,
        fileName: data.fileName,
      })}
    />
  );
};

export const KnowledgeFileAccessRevokedCard = memo(
  KnowledgeFileAccessRevokedCardComponent,
);
